import React from 'react';
import { SimpleGrid, Skeleton } from '@chakra-ui/react';

export const PasswordChangeFormLoader = () => (
  <SimpleGrid columns={1} spacing={4} data-testid="password-change-loader">
    <Skeleton height="48px" />
    <Skeleton height="48px" />
    <Skeleton height="48px" />
    <Skeleton height="48px" />
  </SimpleGrid>
);
